/*
    Menu Scripts
*/
var mm;
function mobilemenu() {
    var self = this;
    // Get Elements
    this.doc = wcbs.dom.get(document);
    this.bdv = wcbs.dom.get(document.body.getElementsByTagName("DIV")[0]);
    this.mb = wcbs.dom.get("b-mm");
    this.nm = wcbs.dom.get("n-mm");
    this.hdr = wcbs.dom.get(document.body.getElementsByTagName("HEADER")[0]);
    this.nmopen = false;
    this.hdry = 0;

    // Special Links
    this.bv = wcbs.dom.get("b-val");
    this.bf = wcbs.dom.get("b-mfav");
    this.bp = wcbs.dom.get("b-mpfl");
    this.bc = wcbs.dom.get("b-mcnt");
    this.bs = wcbs.dom.get("b-search");
    this.bfs = wcbs.dom.get("b-flt");
    this.bb = wcbs.dom.get("d-flt");
    this.bclose = wcbs.dom.get("b-close");
    this.maintenance = wcbs.dom.get("maintenance");
    this.maintOpen = wcbs.dom.get("maint-open");
    this.maintBack = wcbs.dom.get("maint-back");
    this.emergency = wcbs.dom.get("emergency");
    this.emerOpen = wcbs.dom.get("emer-open");
    this.emerBack = wcbs.dom.get("emer-back");
    this.mainContact = wcbs.dom.get("mainContact");
    this.sbvw = wcbs.dom.get("pflist");
    this.submenu = wcbs.dom.get("submenu");
    this.submenuTrigger = wcbs.dom.get("submenu-trigger");
    this.submenuMobileTrigger = wcbs.dom.get("submenu-mobileTrigger");

    this.signupButtons = [].slice.call(document.querySelectorAll(".sign-up-open"));
    this.atv = null;
    // Store the currently open sub menu
    this.so = null;

    this.scrlmnu = function (e) {
        var sT = typeof window.pageYOffset == 'number' ? window.pageYOffset : document.body && (document.body.scrollLeft || document.body.scrollTop) ? document.body.scrollTop : document.documentElement.scrollTop;
        sT = sT < 0 ? 0 : sT;
        if (sT < self.hdry) {
            self.hdr.attr("style", "position: absolute; top: " + sT + "px");
            self.hdry = sT;
        }
    };

    this.toggle = function () {
        self.nm.csstoggle("show");
        if (self.nmopen) {
            // Close
            self.hdr.attr("style", "");

            self.doc.removeevent("scroll", self.scrlmnu);

            self.nmopen = false;
        }
        else {
            // Open
            // Unfix the header and monitor so we don't scroll above it
            var sY;
            self.hdry = window.scrollY ? window.scrollY : document.body.scrollTop > document.documentElement.scrollTop ? document.body.scrollTop : document.documentElement.scrollTop;
            self.hdr.attr("style", "position: absolute; top: " + self.hdry + "px");

            self.doc.event("scroll", self.scrlmnu);

            self.nmopen = true;
        }
    };

    this.asdShow = function (c, e) {
        e.preventDefault();
        if (self.bb.object !== null) { self.bb.cssremove("o"); }
        if (self.atv == c) {
            self.asdClose();
            if (self.submenu.object !== null) { self.submenu.cssremove("hidden"); }
        }
        else {
            if (self.atv != null) { self.bdv.cssremove(self.atv); }
            self.bdv.cssadd(c);
            self.bdv.cssadd("ao");
            if (self.submenu.object !== null) { self.submenu.cssadd("hidden"); }
            self.atv = c;

            // Check if favourites need initialising
            ppf.checkinit();

            scrl.startscroll(wcbs.dom.get(document.body));

            // If menu is open close it
            if (self.nmopen) {
                self.toggle();
            }
        }
    };

    this.searchShow = function (c, e) {
        e.preventDefault();

        if (self.bb.object === null) {
            self.asdClose();
            scrl.startscroll(wcbs.dom.get(document.body));
        } else {
            if (self.atv == c) {
                self.bb.cssremove("o");
                self.atv = null;
            } else {
                self.asdClose();
                self.atv = c;
                self.bb.cssadd("o");
            }
        }
    };

    this.searchShowProperty = function (c, e) {
        e.preventDefault();
        scrl.startscroll(wcbs.dom.get(document.body));
    };

    this.asdClose = function () {
        if (self.atv != null) { self.bdv.cssremove(self.atv); }
        self.bdv.cssremove("ao");
        if (self.bb.object != null) { self.bb.cssremove("o"); }

        self.atv = null;
    };

    this.contactUsToggle = function () {
        self.maintenance.csstoggle("hidden");
        self.mainContact.csstoggle("hidden");
        scrl.startscroll(wcbs.dom.get(document.body));
    };

    this.bvwToggle = function () {
        self.sbvw.csstoggle("bvw");
        scrl.startscroll(wcbs.dom.get(document.body));
    };

    this.toggleSubmenu = function () {
        self.submenu.csstoggle("submenu-open");
        self.submenuTrigger.csstoggle("submenu-btnOpen");
        self.submenuMobileTrigger.csstoggle("submenu-mobileTriggerOpen");
    };

    this.openSignUp = function (c, e) {
        self.asdShow(c, e);
        siManager.signUpform(siManager);
    };

    this.toggleMaint = function (f) {
        if (f === true) {
            self.maintenance.cssremove("hidden");
            self.mainContact.cssadd("hidden");
        }
        else {
            self.maintenance.csstoggle("hidden");
            self.mainContact.csstoggle("hidden");
        }
        document.querySelectorAll(".fixflo-iframe")[0].src = "https://cpshomes.fixflo.com/issue/plugin";
    };

    this.toggleEmer = function (f) {
        if (f === true) {
            self.emergency.cssremove("hidden");
            self.maintenance.cssadd("hidden");
        }
        else {
            self.emergency.csstoggle("hidden");
            self.maintenance.csstoggle("hidden");
        }
    };

    this.setupFooter = function () {
        var toggles = [].slice.call(document.querySelectorAll(".mainFooter nav h2"));

        toggles.forEach(function (toggle) {
            wcbs.dom.get(toggle).event("click", self.toggleFooter);
        });
    };

    this.toggleFooter = function (e) {
        e.preventDefault();
        var el = e.target;
        while (el.tagName !== "H2") {
            el = el.parentElement;
        }
        var list = el.nextElementSibling;

        list.classList.toggle("show");
    };

    this.profileShow = function (e) {
        if (self.bp.object.querySelectorAll("img:first-of-type")[0].classList.contains("hidden")) {
            window.location.href = "/my-account.aspx";
        } else {
            self.asdShow("myAccount-selected", e);
        }
    };

    // Add handlers
    this.mb.event("click", this.toggle);
    this.bv.event("click", this.asdShow, "yourValuation-selected");
    this.bf.event("click", this.asdShow, "myFavs-selected");
    this.bp.event("click", this.profileShow);
    this.bc.event("click", this.asdShow, "contactUs-selected");
    this.maintOpen.event("click", this.toggleMaint);
    this.maintBack.event("click", this.toggleMaint);
    this.emerOpen.event("click", this.toggleEmer);
    this.emerBack.event("click", this.toggleEmer);
    this.setupFooter();

    if (this.bs.object !== null) { this.bs.event("click", this.searchShow, "search-selected"); }
    if (this.bfs.object !== null) { this.bfs.event("click", this.searchShow, "search-selected"); }

    this.signupButtons.forEach(function (signUpButton) {
        wcbs.dom.get(signUpButton).event("click", self.openSignUp, "myAccount-selected");
    });

    this.bclose.event("click", this.asdClose);
    if (this.submenuTrigger.object !== null) { this.submenuTrigger.event("click", this.toggleSubmenu); }
    if (this.submenuMobileTrigger.object !== null) { this.submenuMobileTrigger.event("click", this.toggleSubmenu); }

    // Handle opening sub menus
    for (var i = 0; i < this.nm.object.getElementsByTagName("UL")[0].childNodes.length; i++) {
        if (this.nm.object.getElementsByTagName("UL")[0].childNodes[i].tagName == "LI" && this.nm.object.getElementsByTagName("UL")[0].childNodes[i].className == "" && this.nm.object.getElementsByTagName("UL")[0].childNodes[i].getElementsByTagName("UL").length > 0) {
            new menusublink(wcbs.dom.get(this.nm.object.getElementsByTagName("UL")[0].childNodes[i]), this);
        }
    }

    // Close sub menu if window is resized
    this.resize = function () {
        // If above navicon size and there is an open menu close it
        if (self.so != null && document.body.offsetWidth > 870) {
            self.so.toggle(true);
        }
    };

    wcbs.onresizeAdd("mm.resize()");

    // Handle filters
    this.togglefilters = function () {
        self.fd.csstoggle("show");
    };

    /*if (this.fb.object != null) {
         this.fb.event("click", this.togglefilters);
     }*/

    return this;
}

wcbs.onloadAdd("ppf.init()");
wcbs.onloadAdd("mm = new mobilemenu()");

function menusublink(o, p) {
    this.li = o;
    this.a = wcbs.dom.get(this.li.object.getElementsByTagName("A")[0]);
    this.sm = wcbs.dom.get(this.li.object.getElementsByTagName("UL")[0]);
    this.parent = p;

    var self = this;

    this.toggle = function (c) {
        // If forcing a close just close and reset stored
        if (c == true) {
            self.li.cssremove("show");
            if (self.parent.so == self) {
                self.parent.so = null;
                self.sm.attr("style", "");
            }
        }
        else {
            // If there's a different menu open close it
            if (self.parent.so != null && self.parent.so != self) {
                self.parent.so.toggle(true);
            }
            // If this menu is not open store it
            if (self.parent.so == null) {
                self.parent.so = self;
                self.sm.attr("style", "max-height: " + self.mh + "px");
            }
            else {
                self.parent.so = null;
                self.sm.attr("style", "");
            }
            // Toggle the clicked menu
            self.li.csstoggle("show");
        }
    };

    this.a.event("mousedown", self.toggle);

    // Set the max height on the sub menu
    this.mh = this.sm.object.getElementsByTagName("LI").length * this.sm.object.getElementsByTagName("LI")[0].offsetHeight;

}
